import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import 'react-slidedown/lib/slidedown.css';
import 'rc-slider/assets/index.css';
import { ColorPalette } from 'theme/colors';

export const GlobalStyle = createGlobalStyle`
  ${reset}

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif !important;
    -webkit-tap-highlight-color: transparent;

      #react-joyride-step-0 > div {
        display: flex !important;
        top: auto !important;
        bottom: 85px !important;
    }
  }

  html {
    height: 100%;
  }

  #root {
    flex: 1;
  }

  body {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0;
    height: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    @media ${({ theme }) => theme.device.desktop} {
      background: ${ColorPalette.HEX.Lotion2};
      height: auto;
      min-height: 100%;
    }
  }

  h1 {
    font-family: 'Poppins', sans-serif;
    font-size: 40px;
    letter-spacing: 0;
    line-height: 48px;
  }

  h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    letter-spacing: 0;
    line-height: 40px;
  }

  h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    letter-spacing: 0;
    line-height: 32px;
  }

  h4 {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    letter-spacing: 0;
    line-height: 28px;
  }

  h5 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
  }

  p, span, label {
    display: block;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 20px;
    color: ${({ theme }: any) => theme.index.color}
  }

  label {
    padding: 16px 0 8px 0;
  }

  b {
    font-family: 'Poppins', sans-serif;
    font-weight: bold;
  }

  input {
    min-width: 100px;
    color: ${({ theme }) => theme.index.color};
  }

  a {
    color: ${({ theme }) => theme.links.color};
  }

  button {
    outline: none;
    border: none;
  }

  .icons {
    color: ${({ theme }: any) => theme.index.icons}
  }

  .fade-enter{
    opacity: 0;
  }
  .fade-exit{
    opacity: 1;
  }
  .fade-enter-active{
    opacity: 1;
  }
  .fade-exit-active{
    opacity: 0;
  }
  .fade-enter-active,
  .fade-exit-active{
    transition: opacity 500ms;
  }
`;
